/* eslint-disable jsx-a11y/anchor-is-valid */
// MpResult — página de retorno de Mercado Pago (back_urls).
// Rutas: /mp/success · /mp/failure · /mp/pending
// MP agrega ?payment_id=&status=&external_reference=... Consultamos el estado
// real al back (getMpStatus) para no confiar solo en el query.
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MDBSpinner } from "mdb-react-ui-kit";
import TopBar from "../components/TopBar";
import { getMpStatus } from "../utils/mpApi";

const UI = {
  approved: {
    badge: "xp-badge-success",
    icon: "fa-check",
    title: "¡Pago aprobado!",
    sub: "Tu pago se procesó correctamente. Ya puedes cerrar esta ventana.",
  },
  pending: {
    badge: "xp-badge-neutral",
    icon: "fa-clock",
    title: "Pago pendiente",
    sub: "Tu pago está siendo procesado. Te avisaremos cuando se confirme.",
  },
  rejected: {
    badge: "xp-badge-error",
    icon: "fa-times",
    title: "Pago rechazado",
    sub: "No pudimos procesar tu pago. Intenta nuevamente o usa otro medio.",
  },
};

export default function MpResult({ variant }) {
  const [params] = useSearchParams();
  const paymentId = params.get("payment_id") || params.get("collection_id");
  const queryStatus = params.get("status") || params.get("collection_status");
  const org = params.get("org");

  const [loading, setLoading] = useState(!!paymentId);
  const [status, setStatus] = useState(
    variant === "success" ? "approved" : variant === "failure" ? "rejected" : "pending"
  );
  const [orderId, setOrderId] = useState("");
  const [amount, setAmount] = useState(null);

  useEffect(() => {
    if (queryStatus === "approved") setStatus("approved");
    else if (queryStatus === "rejected") setStatus("rejected");
    if (!paymentId) return;
    let alive = true;
    (async () => {
      const resp = await getMpStatus(paymentId, org);
      if (!alive) return;
      setLoading(false);
      if (resp.status) {
        const s = resp.paymentStatus;
        setStatus(s === "approved" ? "approved" : s === "rejected" || s === "cancelled" ? "rejected" : "pending");
        setOrderId(resp.orderId || "");
        setAmount(resp.amount ?? null);
      }
    })();
    return () => {
      alive = false;
    };
  }, [paymentId, queryStatus, org]);

  const ui = UI[status] || UI.pending;

  return (
    <>
      <TopBar subtitle="Resultado del pago" />
      <div className="xp-page">
        <div className="xp-card">
          {loading ? (
            <>
              <h2>Confirmando tu pago</h2>
              <p className="xp-loading-msg">Un momento, estamos verificando el estado…</p>
              <div className="contenedor-loader">
                <MDBSpinner grow color="info" style={{ width: "2rem", height: "2rem" }}>
                  <span className="visually-hidden">Loading...</span>
                </MDBSpinner>
              </div>
            </>
          ) : (
            <>
              <div className={`xp-badge ${ui.badge}`}>
                <i className={`fas ${ui.icon}`}></i>
              </div>
              <h2>{ui.title}</h2>
              <p className="xp-sub">{ui.sub}</p>
              <div className="xp-summary">
                {orderId && (
                  <div className="xp-summary-row">
                    <span>Pedido</span>
                    <b>{orderId}</b>
                  </div>
                )}
                {amount != null && (
                  <div className="xp-summary-row">
                    <span>Monto</span>
                    <b>{amount}</b>
                  </div>
                )}
                {paymentId && (
                  <div className="xp-summary-row">
                    <span>ID de pago</span>
                    <b>{paymentId}</b>
                  </div>
                )}
              </div>
            </>
          )}
          <div className="xp-trust">
            <i className="fas fa-lock"></i> Pago seguro · Transacción protegida
          </div>
        </div>
      </div>
    </>
  );
}
